// PKCE (RFC 7636) helpers for the OAuth authorization code flow.

// 32 random bytes is the entropy used for every code verifier here.
// Base64url encoded that gives a 43 character verifier, the shortest
// length RFC 7636 allows (43-128 characters).
export const PKCE_VERIFIER_BYTES = 32;

const base64UrlEncode = (bytes) => {
  let binary = "";
  for (let byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export const generateCodeVerifier = (byteLength = PKCE_VERIFIER_BYTES) => {
  const bytes = new Uint8Array(byteLength);
  window.crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
};

export const generateCodeChallenge = async (codeVerifier) => {
  const digest = await window.crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(codeVerifier)
  );
  return base64UrlEncode(new Uint8Array(digest));
};

// Returns the pair to start an authorization request with: keep the
// verifier until the token exchange, send the challenge to the server.
export const generatePkcePair = async () => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  return { codeVerifier, codeChallenge, codeChallengeMethod: "S256" };
};
